// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chatview_content {
    background-color: white;
    padding: 0px;
}
.external_chatbot_box {
    width: 300px;
    height: 500px;
    /* border: solid 1px #e0e0e0; */
    /* border-radius: 4px; */
    display: flex;
    flex-direction: column;
}
.chat_layout {
    flex: 1 1;
    overflow-y: auto;
}
.chat_time {
    margin: 0px 23px;
    font-size: 12px;
    color: darkgrey;
}
.bot_text {
    display: flex;
    flex-direction: row;
    max-width: calc(100% - 50px);
    margin-left: 5px;
    margin-top: 3px;
}
.textbox {
    position: relative;
    display: inline-block;
    max-width: calc(100% - 50px);
    text-align: start;
    padding: 10px;
    margin-top: 7px;
    font-size: 11px;
    border-radius: 10px;
}
.textbox::before {
    position: absolute;
    display: block;
    top: 0;
    font-size: 1.5rem;
}
.bot {
    display: flex;
    flex-direction: row;
}
.user {
    display: flex;
    flex-direction: row-reverse;
}
.bot_text .textbox {
    margin-left: 20px;
    background-color: #ddd;
}
.bot_text .textbox::before {
    left: -15px;
    content: "◀";
    color: #ddd;
}
.user_text {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 5px;
    margin-top: 3px;
}
.user_text .textbox {
    margin-right: 20px;
    background-color: #F9EB54;
}
.user_text .textbox::before {
    right: -15px;
    content: "▶";
    color: #F9EB54;
}
.input_Layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 50px;
    border-top: solid 1px #e0e0e0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}
.input_box {
    flex: 1 1;
    padding: 15px 10px;
    font-size: 12px;
}
.send_button {
    height: 50px;
    width: 60px;
    background-color: #2898ec;
    display: flex;
    justify-content:center;
    align-items: center;
}
.send_icon {
    height: 20px;
    width: 20px;
    fill: white;
}
.left {
    height: 20px;
    width: 20px;
    fill: white;
}
.icon {
    width: 40px;
    height: 40px;
    object-fit:cover;
}
.chat_knowledge_content {
    margin: 15px;
    padding: 10px;
    background: #e0e0e0;
    border-radius: 7px;
    font-size: 12px;
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/pages/external/chatView.css"],"names":[],"mappings":";AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,wBAAwB;IACxB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,SAAO;IACP,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,4BAA4B;IAC5B,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,MAAM;IACN,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;AACnC;AACA;IACI,SAAO;IACP,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["\r\n.chatview_content {\r\n    background-color: white;\r\n    padding: 0px;\r\n}\r\n.external_chatbot_box {\r\n    width: 300px;\r\n    height: 500px;\r\n    /* border: solid 1px #e0e0e0; */\r\n    /* border-radius: 4px; */\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.chat_layout {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n}\r\n.chat_time {\r\n    margin: 0px 23px;\r\n    font-size: 12px;\r\n    color: darkgrey;\r\n}\r\n.bot_text {\r\n    display: flex;\r\n    flex-direction: row;\r\n    max-width: calc(100% - 50px);\r\n    margin-left: 5px;\r\n    margin-top: 3px;\r\n}\r\n.textbox {\r\n    position: relative;\r\n    display: inline-block;\r\n    max-width: calc(100% - 50px);\r\n    text-align: start;\r\n    padding: 10px;\r\n    margin-top: 7px;\r\n    font-size: 11px;\r\n    border-radius: 10px;\r\n}\r\n.textbox::before {\r\n    position: absolute;\r\n    display: block;\r\n    top: 0;\r\n    font-size: 1.5rem;\r\n}\r\n.bot {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n.user {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n}\r\n.bot_text .textbox {\r\n    margin-left: 20px;\r\n    background-color: #ddd;\r\n}\r\n.bot_text .textbox::before {\r\n    left: -15px;\r\n    content: \"◀\";\r\n    color: #ddd;\r\n}\r\n.user_text {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    margin-right: 5px;\r\n    margin-top: 3px;\r\n}\r\n.user_text .textbox {\r\n    margin-right: 20px;\r\n    background-color: #F9EB54;\r\n}\r\n.user_text .textbox::before {\r\n    right: -15px;\r\n    content: \"▶\";\r\n    color: #F9EB54;\r\n}\r\n.input_Layout {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 50px;\r\n    border-top: solid 1px #e0e0e0;\r\n    border-bottom-left-radius: 4px;\r\n    border-bottom-right-radius: 4px;\r\n}\r\n.input_box {\r\n    flex: 1;\r\n    padding: 15px 10px;\r\n    font-size: 12px;\r\n}\r\n.send_button {\r\n    height: 50px;\r\n    width: 60px;\r\n    background-color: #2898ec;\r\n    display: flex;\r\n    justify-content:center;\r\n    align-items: center;\r\n}\r\n.send_icon {\r\n    height: 20px;\r\n    width: 20px;\r\n    fill: white;\r\n}\r\n.left {\r\n    height: 20px;\r\n    width: 20px;\r\n    fill: white;\r\n}\r\n.icon {\r\n    width: 40px;\r\n    height: 40px;\r\n    object-fit:cover;\r\n}\r\n.chat_knowledge_content {\r\n    margin: 15px;\r\n    padding: 10px;\r\n    background: #e0e0e0;\r\n    border-radius: 7px;\r\n    font-size: 12px;\r\n    text-align: left;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
